<template>
  <div class="dialog-wrap">
    <el-dialog title="管理员创建"
               :close-on-click-modal="false"
               :visible.sync="dialogVisible"
               @close="handleClose"
               width="480px">
      <el-form class="form"
               :model="dataForm"
               :rules="rules"
               ref="dataForm"
               label-width="100px">
        <el-form-item label="用户名称"
                      prop="username">
          <el-input v-model="dataForm.username"
                    placeholder="请输入管理员用户名称"></el-input>
        </el-form-item>
        <el-form-item label="昵称"
                      prop="nickname">
          <el-input v-model="dataForm.nickname"
                    placeholder="请输入管理员昵称"></el-input>
        </el-form-item>
        <el-form-item label="手机号"
                      prop="mobile">
          <el-input v-model="dataForm.mobile"
                    placeholder="请输入管理员手机号"></el-input>
        </el-form-item>
        <el-form-item label="登录密码"
                      prop="password">
          <el-input type="password"
                    v-model="dataForm.password"
                    placeholder="请输入管理员登录密码"></el-input>
        </el-form-item>
        <el-form-item label="选择部门"
                      prop="roles">
          <el-select v-model="dataForm.depts"
                     multiple
                     placeholder="请选择"
                     style="width:340px;">
            <el-option v-for="item in deptoptions"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择角色"
                      prop="roles">
          <el-select v-model="dataForm.roles"
                     multiple
                     placeholder="请选择"
                     style="width:340px;">
            <el-option v-for="item in options"
                       :key="item.id"
                       :label="item.title"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="在线状态"
                      prop="status">
          <el-switch v-model="dataForm.status"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary"
                   @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  adminCreate,
  adminRoleList,
  adminUpdate,
  adminPermissions,
  deptlist,
} from '@/api/admin'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogVisible: this.visible,
      dataForm: {},
      rules: {
        username: [
          { required: true, message: '请输入管理员用户名', trigger: 'blur' },
        ],
        nickname: [
          { required: false, message: '请输入管理员昵称', trigger: 'blur' },
        ],
        mobile: [
          {
            required: false,
            message: '请输入管理员手机号',
            trigger: 'blur',
            pattern: /^[0-9]{11}$/,
          },
        ],
        password: [
          {
            required: true,
            message: '请输入管理员登录密码',
            trigger: 'blur',
            min: 6,
          },
        ],
      },
      options: [],
      deptoptions: [],
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
      if (val) {
        this.fetchAdminRoleList()
        this.fetchAdminDeptList()
      }
    },
  },
  methods: {
    fetchAdminRoleList() {
      adminRoleList({ isPaing: 0 }).then((res) => {
        this.options = res.list
      })
    },
    fetchAdminDeptList() {
      deptlist({ isPaing: 0 }).then((res) => {
        this.deptoptions = res.list
      })
    },
    handleSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          const params = Object.assign({}, this.dataForm, {
            status: this.dataForm.status ? 1 : 0,
          })
          if (params.depts.length) {
            params.depts = params.depts.join(',')
          }
          if (params.roles.length) {
            params.roles = params.roles.join(',')
          }
          adminCreate(params)
            .then((res) => {
              this.$message.success(`添加成功`)
              this.$refs['dataForm'].resetFields()

              this.$emit('submit')
              this.handleClose()
            })
            .catch((error) => {
              console.log('error: ', error)
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleClose() {
      this.$emit('close')
    },
  },
}
</script>

<style lang="less" scoped>
.dialog-wrap {
  .form {
    margin-bottom: -18px;
  }
}
</style>
